import { Link } from 'react-router-dom'
import { format } from 'date-fns'

interface GroupCardProps {
  group: {
    id: string
    name: string
    description: string | null
    owner: string
    created_at: string
  }
  stats?: {
    members: number
    comments: number
  }
  /** When set, show a Join button (e.g. for groups the user is not in). */
  onJoin?: (groupId: string) => void
  isJoining?: boolean
}

export default function GroupCard({ group, stats, onJoin, isJoining }: GroupCardProps) {
  const createdDate = format(new Date(group.created_at), 'dd/MM/yyyy')

  return (
    <div
      className="rounded-lg p-6 border-2"
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderColor: 'var(--bg-tertiary)',
      }}
    >
      <h3 
        className="text-xl font-bold mb-2"
        style={{ color: 'var(--text-primary)' }}
      >
        {group.name}
      </h3>
      
      {group.description && (
        <p 
          className="mb-4"
          style={{ color: 'var(--text-primary)' }}
        >
          {group.description}
        </p>
      )}

      <div className="mb-4 space-y-1">
        <p 
          className="text-sm"
          style={{ color: 'var(--text-primary)' }}
        >
          Owner: {group.owner}
        </p>
        <div className="flex items-center justify-between text-sm">
          <div style={{ color: 'var(--text-primary)' }}>
            <span>{stats?.members ?? 0} members</span>
            <span className="ml-4">{stats?.comments ?? 0} comments</span>
          </div>
          <span style={{ color: 'var(--text-primary)' }}>
            {createdDate}
          </span>
        </div>
      </div>

      <div className="flex gap-2 flex-wrap">
        {onJoin && (
          <button
            type="button"
            onClick={() => onJoin(group.id)}
            disabled={isJoining}
            className="px-4 py-2 font-semibold rounded"
            style={{
              backgroundColor: 'var(--bg-interactive)',
              color: 'var(--text-inverse)',
              opacity: isJoining ? 0.7 : 1,
            }}
          >
            {isJoining ? 'Joining…' : 'Join'}
          </button>
        )}
        <Link
          to={`/groups/${group.id}`}
          className="inline-block text-center px-4 py-2 font-semibold rounded"
          style={{
            backgroundColor: 'var(--bg-tertiary)',
            color: 'var(--text-primary)',
          }}
        >
          View Group
        </Link>
      </div>
    </div>
  )
}

